const Intersection = {
  mounted(el, binding) {
    el._intersection = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        binding.value(entry.isIntersecting);
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.2,
    });

    el._intersection.observe(el);
  },
  beforeUnmount(el) {
    if(el && el._intersection) {
      el._intersection.unobserve(el);
    }
  }
}

export default Intersection;